const probe = '__local_storage_probe__'

export default class Storage {
  constructor(namespace) {
    this.namespace = namespace
    this.isSupported = (() => {
      try {
        localStorage.setItem(probe, probe)
        localStorage.removeItem(probe)
        return true
      } catch (error) {
        return false
      }
    })()
  }

  get(key, defaultValue = null) {
    let storageValue
    if (this.isSupported) {
      storageValue = window.localStorage.getItem(`${this.namespace}_${key}`)
    }
    return storageValue || defaultValue
  }

  remove(key) {
    if (this.isSupported) {
      window.localStorage.removeItem(`${this.namespace}_${key}`)
    }
  }

  set(key, value) {
    if (this.isSupported) {
      window.localStorage.setItem(`${this.namespace}_${key}`, value)
    }
  }
}
